<template>
  <div>
    <!-- Table Container Card -->
    <list-filter
      :kanwil-filter.sync="kanwilFilter"
      :upt-filter.sync="uptFilter"
      :kategori-filter.sync="kategoriFilter"
      :jenis-filter.sync="jenisFilter"
      :status-filter.sync="statusFilter"
      :periode-filter.sync="periodeFilter"
      :kanwilOptions="kanwilOptions.options"
      :kategoriJenisTiketOptions="kategoriJenisTiketOptions.options"
      :jenisTiketOptions="jenisTiketOptions.options"
      :statusTiketOptions="statusTiketOptions.options"
      :uptOptions="uptOptions.options"
      @emitReceiverUPT="reloadUPTOptions"
      @emitReceiverKategori="reloadKategoriOptions"
    />
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <!-- <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
            </div> -->
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchDatas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: User -->
        <template #cell(jenis_keterampilan)="data">
          <b-media vertical-align="center">
            {{ data.item.jenis_keterampilan }}
            <small class="text-muted">{{ data.item.alamat }}</small>
          </b-media>
        </template>

        <template #cell(status_keterampilan)="data">
          <b-media vertical-align="center">
            {{ data.item.status_keterampilan }}
            <small class="text-muted">{{ data.item.alamat }}</small>
          </b-media>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-button
            class="mr-1 btn-icon btn btn-relief-primary mt-1"
            variant="primary"
            v-if="checkProses(data)"
            :to="{ name: 'pages-tiket-lacak-lihat', params: { id: data.item.id } }"
            title="Lihat Data"
            alt="Lihat Data"
          >
            <feather-icon icon="ZoomInIcon" />
          </b-button>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Menampilkan {{ dataMeta.from }} per {{ dataMeta.to }} dari {{ dataMeta.of }} data
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  getKategoriJenisTiket,
  getStatusTiketAll,
  getKanwil,
  getUPT,
  getJenisTiketByIdKateg,
} from '@/connection-api/master'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/connection-api/tiket-lacak-table/storeModule'
import useList from '@/connection-api/tiket-lacak-table/list'

import { approve, tolak } from '@/connection-api/tiket'
import ListFilter from './ListFilter.vue'
// import listAddNew from './ListAddNew.vue'
// import listFilters from './ListFilters.vue'

export default {
  components: {
    // listFilters,
    // listAddNew,

    BCard,
    BRow,
    BCol,
    // BFormInput,
    BButton,
    BTable,
    BMedia,
    // BLink,
    // BDropdown,
    // BDropdownItem,
    BPagination,
    ListFilter,
    vSelect,
  },
  data() {
    return {
      uptOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih UPT --' }],
      },
      kanwilOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Jenis Kanwil --' }],
      },
      kategoriJenisTiketOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Kategori --' }],
      },
      jenisTiketOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Jenis --' }],
      },
      statusTiketOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Status --' }],
      },
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  async mounted() {
    const responseKanwil = await getKanwil()
    this.mappingSelectOptionKanwil(responseKanwil.data, this.kanwilOptions.options)

    const response = await getKategoriJenisTiket()
    this.mappingSelectOption(response.data, this.kategoriJenisTiketOptions.options)

    const responseStatusTiket = await getStatusTiketAll()
    this.mappingSelectOption(responseStatusTiket.data, this.statusTiketOptions.options)
  },
  methods: {
    checkProses(data) {
      let returnData = true
      if (data.item.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe22') {
        returnData = false
      }
      return returnData
    },
    async reloadUPTOptions(kanwilId) {
      this.uptFilter = null
      this.uptOptions = {
        selected: 'id',
        options: [{ value: null, label: '--Pilih UPT --' }],
      }
      const responseUptOptions = await getUPT(kanwilId)
      this.mappingSelectOption(responseUptOptions.data, this.uptOptions.options)
    },
    async reloadKategoriOptions(kategoriId) {
      this.jenisFilter = null
      this.kategoriFilter = null
      this.jenisTiketOptions = {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Jenis --' }],
      }
      const responseJenisOptions = await getJenisTiketByIdKateg(kategoriId)
      this.mappingSelectOption(responseJenisOptions.data, this.jenisTiketOptions.options)
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
    mappingSelectOptionKanwil(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        title: 'Tiket',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    emitAddSuccess(jenisTiketId) {
      this.$router.replace(`/kelola-jenistiket/edit/${jenisTiketId}`).then(() => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Jenis',
            icon: 'CoffeeIcon',
            variant: 'success',
            text: 'Data berhasil di tambahkan',
          },
        })
      })
    },
    isExist(data) {
      if (this.onlyView === true) {
        return false
      }
      if (
        // eslint-disable-next-line operator-linebreak
        data.user_tiket_all.length > 0 &&
        // eslint-disable-next-line operator-linebreak
        data.user_tiket &&
        // eslint-disable-next-line operator-linebreak
        data.user_tiket[0] &&
        data.user_tiket[0].status_approval_id === '24a99fbd-2545-11ee-acb1-3497f616fa2'
      ) {
        return true
      }
      return false
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'keterampilan'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) {
      store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(USER_APP_STORE_MODULE_NAME)
      }
    })

    const isAddNewUserSidebarActive = ref(false)

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      kanwilFilter,
      uptFilter,
      kategoriFilter,
      jenisFilter,
      statusFilter,
      periodeFilter,

      // jenisUptFilter,
      // uptFilter,
      // jenisAssetFilter,
      // statusAssetFilter,
    } = useList()

    return {
      // Sidebar
      isAddNewUserSidebarActive,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      kanwilFilter,
      uptFilter,
      kategoriFilter,
      jenisFilter,
      statusFilter,
      periodeFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
